import React from 'react'
import className from 'classnames/bind'
import { Button } from 'app/components/common'
import { NotesIcon } from 'app/components/icons'

import stylesModule from 'app/components/sounds/sound-popup/sound-popup-main/sound-popup-main.module.scss'
import { Sound } from 'app/components/sounds/types/sound'

const cx = className.bind(stylesModule)

type SoundPopupSongVideoButtonProps = { onSongClick: () => void; sound: Sound }

const SoundPopupSongVideoButton = ({
  onSongClick,
  sound,
}: SoundPopupSongVideoButtonProps) =>
  sound.songvideo ? (
    <Button
      className={cx('media-button', 'violet')}
      onClick={onSongClick}
      aria-label={`Play song video for ${sound.soundname}`}
    >
      <NotesIcon className={cx('media-button__icon')} />
    </Button>
  ) : null

export default SoundPopupSongVideoButton
